// extracted by mini-css-extract-plugin
export default {"wrap":"LanguageSelectComponent_wrap__7Fbjo","selectLanguage":"LanguageSelectComponent_selectLanguage__PvKSo"};